import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { PropTypes } from "prop-types"
import { reduxForm, formValueSelector } from 'redux-form'
import { optOutAdvancer, fetchPostEvent, resetPostEventWizard } from '../../../../redux/actions/action_postEvent';
import { isEmpty } from '../../../../utils/functions';
import ContentWrapper from "../../../../components/layout/ContentWrapper"
import SearchBar, { SearchBy } from './searchbar';
import SearchResults from './searchresults'

const formName = 'postevent'

class ManageAdvancers extends Component 
{
  constructor(props)
  {
    super(props);
    this.state = {
      showSearchResults:false
    }
    this.onHandleOptOutAdvancer = this.onHandleOptOutAdvancer.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleViewEventDetails = this.handleViewEventDetails.bind(this);
  }

  componentWillReceiveProps = (nextProps)=> {
		if (nextProps.location.key !== this.props.location.key) 
		{
			this.setState(
			{
            showSearchResults:false
			});
		}
  }

  onHandleOptOutAdvancer(advancerId)
  {
    const { dispatch } = this.props;
    dispatch(optOutAdvancer(advancerId));
  }

  handleSearch(){
    this.setState({
       showSearchResults:true
    })
  }

  handleViewEventDetails(eventId) {
    this.props.dispatch(resetPostEventWizard());
    this.props.dispatch(fetchPostEvent(eventId));
    this.props.history.push('/postevent');
    this.setState({
      showSearchResults: false,
    });
  }

  render()
   {  
    const { showSearchResults } = this.state;
    const { advancers, oidc } = this.props;

    const  token =  isEmpty(oidc.user) === false ? oidc.user.access_token: '';
    const refreshResults = this.props.refreshSearchBar !== undefined ? this.props.refreshSearchBar:false;
    const showResults = showSearchResults && (advancers !== undefined); 

    return (
      <ContentWrapper>
        <div className="content-heading">Manage Advancers</div>
        <SearchBar
            token={token}
            SearchByDefault={SearchBy.DirectorName}
            SearchByChange={this.onHandleSearchByChange}
            onSearch={this.handleSearch}
            refreshResults={refreshResults}
        />
        {
          showResults &&
          <SearchResults 
              searchResults={advancers} 
              showAdjustment={this.onHandleShowAdjustment} 
              showTransfer={this.onHandleShowTransfer}
              onViewEventDetails={this.handleViewEventDetails}
              optOutAdvancer={this.onHandleOptOutAdvancer}
          />
        }
    </ContentWrapper>)
  }
}

ManageAdvancers.propTypes = {
  dispatch: PropTypes.func,
  oidc: PropTypes.object,
  advancers: PropTypes.array,
	history: PropTypes.object,
  refreshSearchBar: PropTypes.bool,
  location: PropTypes.object
}

function mapStateToProps(state,ownProps){
  const formName              =  ownProps.form;
  const selector              = formValueSelector(formName);
  const advancers             = selector(state, 'advancers');
  const refreshSearchBar      = selector(state, 'refreshSearchBar');
  return {
     advancers,
     refreshSearchBar,
     oidc: { ...state.oidc }
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchPostEvent,
    resetPostEventWizard,
    optOutAdvancer
    },dispatch)
}

export default reduxForm({
  form:formName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(ManageAdvancers))



// WEBPACK FOOTER //
// ./src/containers/postevent/components/manageAdvancers/index.js